import * as React from "react";
import { Img } from "../../../Img";
export const MethodImage = (props) => (React.createElement("div", { className: "method-image" },
    React.createElement(Img, { src: props.imageURL, alt: props.imageAlt })));
